///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { ProjectDTO } from '../generated/shared-types.model';

@Injectable({
    providedIn: 'root'
})
export class ProjectRoutingStateService {
    private lastOpenedProject: ProjectDTO;

    public rememberLastOpened(project: ProjectDTO): void {
        // saves or overwrites last project
        this.lastOpenedProject = project;
    }

    public getLastAndForget(): ProjectDTO {
        // navigation by project should happen only once - right after we closed the project
        const project = this.lastOpenedProject;
        this.lastOpenedProject = undefined;
        return project;
    }
}
